"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPublic = exports.isSecret = void 0;
var types_1 = require("@wix/ambassador-social-groups-v2-group/types");
function isSecret(group) {
    return group.privacyLevel === types_1.PrivacyLevel.SECRET;
}
exports.isSecret = isSecret;
function isPublic(group) {
    return group.privacyLevel === types_1.PrivacyLevel.PUBLIC;
}
exports.isPublic = isPublic;
//# sourceMappingURL=index.js.map